<div id="mauticform_wrapper_progress" class="mauticform_wrapper">
  <form autocomplete="false" role="form" method="post" action="{{ formApiUrl }}?formId=27" id="mauticform_progress" data-mautic-form="progress" enctype="multipart/form-data" #form>
      <div class="mauticform-error" id="mauticform_progress_error"></div>
      <div class="mauticform-message" id="mauticform_progress_message"></div>
      <div class="mauticform-innerform">
          
        <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

          <div id="mauticform_progress_email" class="mauticform-row mauticform-email mauticform-field-1">
              <label id="mauticform_label_progress_email" for="mauticform_input_progress_email" class="mauticform-label">E-mail</label>
              <input id="mauticform_input_progress_email" name="mauticform[email]" [value]="formData.email" class="mauticform-input" type="email">
              <span class="mauticform-errormsg" style="display: none;"></span>
          </div>

          <div id="mauticform_progress_passo" class="mauticform-row mauticform-text mauticform-field-2">
              <label id="mauticform_label_progress_passo" for="mauticform_input_progress_passo" class="mauticform-label">Passo</label>
              <input id="mauticform_input_progress_passo" name="mauticform[passo]" [value]="formData.passo" class="mauticform-input" type="text">
              <span class="mauticform-errormsg" style="display: none;"></span>
          </div>

          <div id="mauticform_progress_submit" class="mauticform-row mauticform-button-wrapper mauticform-field-3">
              <button type="submit" name="mauticform[submit]" id="mauticform_input_progress_submit" value="" class="mauticform-button btn btn-default">Submit</button>
          </div>
          </div>
      </div>

      <input type="hidden" name="mauticform[formId]" id="mauticform_progress_id" value="27">
      <input type="hidden" name="mauticform[return]" id="mauticform_progress_return" value="">
      <input type="hidden" name="mauticform[formName]" id="mauticform_progress_name" value="progress">

      </form>
</div>
